<template>
	<div class="app-header">
		<div style="width:50px;float:left;" v-if="currentAccountSets||User.role=='Admin'">
			<Button :icon="sliderCollapsed ? 'icon-align-right':'icon-align-left'" size="l" noBorder class="font20" @click="sliderCollapsed=!sliderCollapsed"></Button>
		</div>
		<div class="float-right app-header-info">

			<app-header-account-sets/>
      <div class="app-header-icon-item" v-if="currentAccountSets">
<!--        <Input :value="currentAccountDate" disabled class="d-input"/>
        <span class="h-input-addon h-icon-calendar as-icon-calendar" ></span>-->
        <el-date-picker style="padding-top: 17px"
                        v-model="currentAccountDate"
                        @change="accountDateChange"
                        type="month"
                        value-format="yyyy-MM"
                        >
        </el-date-picker>
      </div>


			<DropdownMenu className="app-header-dropdown" trigger="click" offset="0 5" :width="150" placement="bottom-end" :datas="infoMenu" @onclick="trigger">
				<Avatar :src="avatarUrl" :width="30"><span>{{User.realName}}</span></Avatar>
			</DropdownMenu>
		</div>
	</div>
</template>
<script>
	import {mapState,mapGetters} from 'vuex';
  import setting from "@/api/setting";
	import moment from 'moment';
	import appHeaderMessage from './modules/app-header-message';
	import AppHeaderAccountSets from "./modules/app-header-account-sets";
  import AccountDateChoose from "@/components/AccountDateChoose";
  import AppHeaderAccountDates from "@/views/app/modules/app-header-account-dates";
  import Home from "../Home";

	export default {
		components: {
      AccountDateChoose,
			AppHeaderAccountSets,
      AppHeaderAccountDates,
			appHeaderMessage,
      Home
		},
		data() {
			return {
				searchText: '',
        currentAccountDate: null,
				infoMenu: [
					{key: 'info', title: '个人信息', icon: 'h-icon-user'},
					{key: 'logout', title: '退出登录', icon: 'h-icon-outbox'}
				]
			};
		},
		computed: {
			...mapState(['User', 'currentAccountSets']),
      ...mapGetters(['checkoutList']),
			sliderCollapsed: {
				get() {
					return this.$store.state.sliderCollapsed;
				},
				set(value) {
					this.$store.commit('updateSliderCollapse', value);
				}
			},
			accountDate() {
				return this.currentAccountSets ? moment(this.currentAccountSets.currentAccountDate).format("yyyy-MM") : null;
			},
			avatarUrl() {
				return this.User.avatarUrl || '/images/yun.png'
			}
		},
    /*watch: {
      accountDate() {
        this.currentAccountDate = this.accountDate;
      }
    },*/
		mounted() {

      this.currentAccountDate= new Date(this.accountDate);
			const resizeEvent = window.addEventListener('resize', () => {
				if (this.sliderCollapsed && window.innerWidth > 900) {
					this.sliderCollapsed = false;
				} else if (!this.sliderCollapsed && window.innerWidth < 900) {
					this.sliderCollapsed = true;
				}
				if (!this.currentAccountSets&&this.User.role!='Admin') {
					this.sliderCollapsed = true;
				}
			});
			this.$once('hook:beforeDestroy', () => {
				window.removeEventListener('resize', resizeEvent);
			});
			window.dispatchEvent(new Event('resize'));
		},
    created() {
      this.getUserInfo();
    },
    methods: {
      getUserInfo() {
        const user = this.User;
      },
			trigger(data) {
				if (data == 'logout') {
					this.$api.common.logout().then(() => {
						window.location.replace("/");
					});
				} else {
					this.$router.push({name: 'PersonalSetting'});
				}
			},
      accountDateChange(val) {

        setting.accountSets.updateCurrentAccountDate(val).then(() => {

          this.$store.dispatch('init');
          window.location.replace("/")
        })

      }
		}
	};
</script>
<style lang="less">
	.app-header {
		color: rgba(49, 58, 70, 0.8);

		.h-autocomplete {
			line-height: 1.5;
			float: left;
			margin-top: 15px;
			margin-right: 20px;
			width: 120px;

			&-show, &-show:hover, &-show.focusing {
				outline: none;
				box-shadow: none;
				border-color: transparent;
				border-radius: 0;
			}

			&-show.focusing {
				border-bottom: 1px solid #eee;
			}
		}

		&-info &-icon-item {
			cursor: pointer;
			display: inline-block;
			float: left;
			padding: 0 15px;
			height: @layout-header-height;
			line-height: @layout-header-height;
			margin-right: 10px;

			&:hover {
				background: @hover-background-color;
			}

			i {
				font-size: 18px;
			}

			a {
				color: inherit;
			}

			.h-badge {
				margin: 20px 0;
				display: block;
			}
		}
    .app-header-icon-item {
      margin-left: 20px;

      button {
        background-color: #ffffff;
      }
    }

		.h-dropdownmenu {
			float: left;
		}

		&-dropdown {
			float: right;
			margin-left: 10px;
			padding: 0 20px 0 15px;

			.h-icon-down {
				right: 20px;
			}

			cursor: pointer;

			&:hover, &.h-pop-trigger {
				background: @hover-background-color;
			}

			&-dropdown {
				padding: 5px 0;

				.h-dropdownmenu-item {
					padding: 8px 20px;
				}
			}
		}

		&-menus {
			display: inline-block;
			vertical-align: top;

			> div {
				display: inline-block;
				font-size: 15px;
				padding: 0 25px;
				color: @dark-color;

				&:hover {
					color: @primary-color;
				}

				+ div {
					margin-left: 5px;
				}

				&.h-tab-selected {
					color: @white-color;
					background-color: @primary-color;
				}
			}
		}
	}
  .d-input {
    height: 34px !important;
    width: 96px !important;
    padding-right: 0 !important;
    border-right: none !important;
    border-radius: 5px 0 0 5px !important;
  }

</style>
